import { apiPut } from '../client';
import { useSessionUser } from '@/store/authStore';
import type { UpdateProfilePayload, UpdateProfileResponse } from '@/@types/account';
import type { ApiException } from '../client';

/**
 * Update user's profile (full name)
 * Also updates the global auth store with new user data
 *
 * @param payload - Object containing the updated name
 * @returns Promise with updated user data
 * @throws ApiException with validation errors if request fails
 */
export async function updateProfile(payload: UpdateProfilePayload): Promise<UpdateProfileResponse> {
    try {
        const response = await apiPut<UpdateProfileResponse>(
            '/app/v1/account/profile',
            payload
        );

        // Update global user state with new name
        const setUser = useSessionUser.getState().setUser;
        setUser({
            userName: response.user.name,
            email: response.user.email,
        });

        return response;
    } catch (error) {
        // Re-throw to allow component-level error handling
        throw error;
    }
}

/**
 * Hook to get validation errors from API exception
 */
export function getProfileValidationErrors(error: any): Record<string, string> {
    const errors: Record<string, string> = {};

    if (error && typeof error === 'object' && 'errors' in error) {
        const apiError = error as ApiException;
        if (apiError.errors) {
            // Convert array of errors to first error message
            const errorFields = Object.keys(apiError.errors);
            errorFields.forEach((field) => {
                const messages = apiError.errors![field];
                if (messages && messages.length > 0) {
                    errors[field] = messages[0];
                }
            });
        }
    }

    return errors;
}

